import { FactualitySensitivity } from '@/shared/types/brain';

import { CreateAIAgentOptions } from './models';

export const CREATE_AI_AGENT_OPTIONS: CreateAIAgentOptions[] = [
  'engagement',
  'activation',
  'upsell',
  'debt_collection',
  'support',
  'import',
] as const;

export const AI_AGENT_REMINDER_FORM_ID = 'ai-agent-reminder';

export const DEFAULT_FACTUALITY_SENSITIVITY = FactualitySensitivity.LOW;
